import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "settingsEditor",
  novalidate: "",
  class: "tray-theme-editor__settings-editor",
  enctype: "multipart/form-data"
}
const _hoisted_2 = { class: "tray-theme-editor__settings-editor__header" }
const _hoisted_3 = { class: "tray-theme-editor__settings-editor__content" }
const _hoisted_4 = { class: "tray-theme-editor__settings-editor__actions" }
const _hoisted_5 = { class: "tray-theme-editor__settings-editor__actions-wrapper" }
const _hoisted_6 = { class: "tray-theme-editor__title" }
const _hoisted_7 = { class: "tray-theme-editor__settings-editor__content-settings" }
const _hoisted_8 = { class: "tray-theme-editor__settings-editor__menu-title" }
const _hoisted_9 = { class: "tray-theme-editor__settings-editor__menu-tray" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "tray-theme-editor__settings-editor__line" }, null, -1)
const _hoisted_11 = { class: "tray-theme-editor__settings-editor__menu-settings" }
const _hoisted_12 = { class: "tray-theme-editor__settings-editor__menu-title" }
const _hoisted_13 = {
  key: 0,
  class: "skeletons"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "skeletons__sessions" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "skeletons__sessions" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "skeletons__sessions" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "skeletons__sessions" }, null, -1)
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "tray-theme-editor__settings-editor__menu-error"
}
const _hoisted_20 = { class: "tray-theme-editor__settings-editor__menu-error-text" }
const _hoisted_21 = {
  key: 0,
  href: "#"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Session = _resolveComponent("Session")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('layout-editor.edit-layout')), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Icon, {
              name: "times-circle",
              "aria-hidden": "true",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('layout-editor.config-tray')), 1),
          _createVNode(_component_Alert, {
            "class-style": "alert tray-theme-editor__settings-editor__alert",
            "input-fields": {
              label: '',
              description: _ctx.$t('layout-editor.alert-config-tray'),
            }
          }, null, 8, ["input-fields"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Session, {
              "title-session": _ctx.$t('layout-editor.logo'),
              "router-session": "logo",
              "icon-config": false,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('set-component', 'LogoEditor')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "tray-theme-editor__settings-editor__menu-icon",
                  name: "star",
                  prefix: "far"
                })
              ]),
              _: 1
            }, 8, ["title-session"]),
            _createVNode(_component_Session, {
              "title-session": _ctx.$t('layout-editor.buttons'),
              "router-session": "button",
              "icon-config": false,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('set-component', 'ButtonEditor')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "tray-theme-editor__settings-editor__menu-icon",
                  name: "plus-square",
                  prefix: "far"
                })
              ]),
              _: 1
            }, 8, ["title-session"]),
            _createVNode(_component_Session, {
              "title-session": _ctx.$t('layout-editor.seals'),
              "router-session": "seal",
              "icon-config": false,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('set-component', 'SealEditor')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "tray-theme-editor__settings-editor__menu-icon",
                  name: "bookmark",
                  prefix: "far"
                })
              ]),
              _: 1
            }, 8, ["title-session"])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('layout-editor.config-theme')), 1),
            (_ctx.verifyLoading('loading'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.verifyLoading('error') || _ctx.verifyLoading('not-found'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_Icon, {
                    prefix: "far",
                    name: "times-circle",
                    class: "tray-theme-editor__icon--icon-error"
                  }),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('components.settings.error')) + _toDisplayString(_ctx.verifyLoading('not-found') ? '.' : ','), 1),
                  (_ctx.verifyLoading('error'))
                    ? (_openBlock(), _createElementBlock("a", _hoisted_21, _toDisplayString(_ctx.$t('components.status-save.info.error.try-again')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.verifyLoading('initial'))
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.settingList, (setting, index) => {
                  return (_openBlock(), _createBlock(_component_Session, {
                    key: index,
                    "title-session": setting.label,
                    "icon-session": setting.icon,
                    "router-config": false,
                    onClick: ($event: any) => (_ctx.selectSession(setting))
                  }, null, 8, ["title-session", "icon-session", "onClick"]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 512))
}